import styled from 'styled-components'

import Event1 from '~/shared/assets/images/event-1.png'
import Event2 from '~/shared/assets/images/event-2.png'
import Event3 from '~/shared/assets/images/event-3.png'
import Event4 from '~/shared/assets/images/event-4.png'
import theme from '~/shared/styles/theme'

interface ImageCardProps {
  $large?: boolean
}

function ImageGrid() {
  return (
    <Wrapper>
      <Row $justifyContent="flex-start" $gap="36px">
        <ImageCard $large src={Event1} alt="Large Image" />
      </Row>
      <Row $gap="20px">
        <ImageCard src={Event2} alt="Small Image 1" />
        <ImageCard src={Event3} alt="Small Image 2" />
        <ImageCard src={Event4} alt="Small Image 3" />
      </Row>
    </Wrapper>
  )
}

export default ImageGrid

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  width: 100%;
`

const Row = styled.div<{ $justifyContent?: string; $gap?: string }>`
  display: flex;
  gap: ${(props) => props.$gap || '16px'};
  justify-content: ${(props) => props.$justifyContent || 'center'};
  width: 100%;

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 16px;
  }
`

const ImageCard = styled.img.attrs<ImageCardProps>(({ $large }) => ({
  $large: $large || false,
}))<ImageCardProps>`
  width: ${(props) =>
    props.$large ? 'calc(100% - 18px)' : 'calc(33.333% - 13.33px)'};
  height: auto;
  object-fit: cover;
  border-radius: 8px;

  @media ${theme.device.medium} {
    width: 100%;
  }
`
